
import { useEffect, useState } from 'react';

export const useAppSiderWidth = (): number => {
  const [appSiderWidth, setAppSiderWidth] = useState(288);

  useEffect(() => {
    let observer: ResizeObserver;
    const appSider = document.getElementById('app-sider');
    if (appSider) {
      observer = new ResizeObserver(changes => {
        if (changes[0]) {
          setAppSiderWidth(changes[0].contentRect.width);
        }
      });
      observer.observe(appSider);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  return appSiderWidth;
};